import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-haiku',
  templateUrl: './haiku.component.html',
  styleUrls: ['./haiku.component.scss']
})
export class HaikuComponent {
  constructor(private dialogRef: MatDialogRef<HaikuComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


